export enum ExperimentStatus {
  'Draft' = 1,
  'Active' = 2,
  'Complete' = 3,
  'Cancelled' = 4, // No longer in use
  'Paused' = 5,
  'DraftLocked' = 6,
}
